<div class="dialog-wrapper">
  <div class="dialog-header">
    @if (headerTpl) {
      <ng-container *ngTemplateOutlet="headerTpl"></ng-container>
    } @else {
      <span class="btn btn-plain close-btn">
        <span mat-dialog-close class="mb-icon mb-icon-close"></span>
      </span>
    }
  </div>
  <div class="dialog-header-content">
    <ng-content select="[dialog-header-content]"></ng-content>
  </div>
  <div class="dialog-content">
    <div class="dialog-content-inner">
      <ng-content select="[dialog-content]"></ng-content>
    </div>
  </div>
</div>
